/* eslint-disable default-case */
/* eslint-disable no-param-reassign */
import _ from 'underscore';
import { BaseSchemaProcessor } from './base-schema-processor';
import { updateOdataOptionsForFinalUrl } from '../util/update-final-url-property-for-filter';

const DeviceTypeLocalizeMap = {
  "Enum.DeviceType'Mobile'": 'HotelCenter_Overview_Grid_DeviceType_Enum_Smartphones',
  "Enum.DeviceType'Tablet'": 'HotelCenter_Overview_Grid_DeviceType_Enum_Tablets',
  "Enum.DeviceType'Desktop'": 'HotelCenter_Overview_Grid_DeviceType_Enum_Computers',
};

export class HotelCenterOverviewSchemaProcessor extends BaseSchemaProcessor {
  updateEntitySchemaForFeatures(entitySchema) {
    const updatedSchema = super.updateEntitySchemaForFeatures(entitySchema);
    _.map(updatedSchema.properties, (item) => {
      if (item.property.indexOf('Metrics/') === 0) {
        item.property = `Performance${item.property}`;
      }
    });

    const {
      Id, BidAmount, DeviceType, PartnerHotelId, Status, Name,
    } = updatedSchema.properties;
    if (Id) {
      switch (updatedSchema.name) {
        case 'Hotel': {
          Id.title = this.passedInI18n.getString('HotelCenter_Overview_Grid_Hotel_ID_Label');
          break;
        }
        case 'HotelGroup': {
          Id.title = this.passedInI18n.getString('HotelCenter_Overview_Grid_Hotel_Group_ID_Label');
          break;
        }
        case 'SubAccount': {
          Id.title = this.passedInI18n.getString('HotelCenter_Overview_Grid_SubAccount_Id_Label');
          break;
        }
      }
    }
    if (BidAmount) {
      BidAmount.title = this.passedInI18n.getString('HotelCenter_Overview_Grid_Bid_Label');
    }
    if (DeviceType) {
      DeviceType.title = this.passedInI18n.getString('HotelCenter_Overview_Grid_DeviceType_Label');
      DeviceType.chooseType = 'checkbox';
      DeviceType.localized = _.mapObject(
        DeviceTypeLocalizeMap,
        EnumValue => this.passedInI18n.getString(EnumValue)
      );
    }
    if (PartnerHotelId) {
      PartnerHotelId.title = this.passedInI18n.getString('HotelCenter_Overview_Grid_Hotel_Advertiser_Hotel_ID_Label');
    }
    if (Status) {
      Status.chooseType = 'checkbox';
      Status.title = this.passedInI18n.getString('HotelCenter_Overview_Grid_SubAccount_Status_Label');
      Status.localized = _.mapObject(Status.enumValueMap, EnumValue => this.passedInI18n.getString(`HotelCenter_Overview_Grid_Status_Enum_${EnumValue}`));
    }
    if (Name) {
      Name.title = this.passedInI18n.getString('HotelCenter_Overview_Grid_SubAccount_Name_Label');
    }

    const propWhitelist = _.compact(['MaximumBidAmount', 'Labels']);

    // Add title for performance in other grids
    if (updatedSchema.name === 'HotelDimensionRow') {
      const {
        Clicks, Impressions, CTR, Spend, AverageCPC, AveragePosition,
      } = updatedSchema.properties;
      Clicks.title = this.passedInI18n.getString('HotelCenter_Overview_Grid_Clicks_Label');
      Impressions.title = this.passedInI18n.getString('HotelCenter_Overview_Grid_Impression_Label');
      CTR.title = this.passedInI18n.getString('HotelCenter_Overview_Grid_CTR_Label');
      Spend.title = this.passedInI18n.getString('HotelCenter_Overview_Grid_Spend_Label');
      AverageCPC.title = this.passedInI18n.getString('HotelCenter_Overview_Grid_AverageCPC_Label');
      AveragePosition.title = this.passedInI18n.getString('HotelCenter_Overview_Grid_AveragePosition_Label');

      propWhitelist.push('AverageCPM');
    }

    if (updatedSchema.name === 'HotelGroup') {
      propWhitelist.push('Status');
    }

    updatedSchema.properties = _.omit(
      updatedSchema.properties,
      propWhitelist
    );
    return updatedSchema;
  }

  updateOdataOptions(odataOptions) {
    super.updateOdataOptions(odataOptions);
    const { fieldMap } = odataOptions;
    _.map(fieldMap, (value, key) => {
      if (value.indexOf('PerformanceMetrics/') === 0) {
        fieldMap[key] = value.replace('PerformanceMetrics/', 'Metrics/');
      }
    });
    updateOdataOptionsForFinalUrl(odataOptions);
    _.extendOwn(odataOptions.custom, {
      DeviceType: {
        eq: (filterValues) => {
          const queryStr = `DeviceType eq ${filterValues.replace('Enum.DeviceType', '')}`;
          return queryStr;
        },
      },
    });
    return odataOptions;
  }
}
